<template>
  <main class="layout-container">
    <div class="page-view">
      <NuxtPage />
    </div>
    <s-sidebar v-if="!isSidebarHidden" />
  </main>
</template>

<script setup >
import { useRoute } from 'vue-router';
import { useThemeStore } from '~/store/theme';

const route = useRoute();

const themeStore = useThemeStore();

onBeforeMount(() => {
  themeStore.init();
});

const isSidebarHidden = computed(() => {
  return route.query.codigo;
});

</script>

<style scoped>

.layout-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  box-sizing: border-box;
  margin: 0px 0px 0px 65px;
  position: relative;
  min-width: 300px;
}
.page-view {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 5px 15px;
  box-sizing: border-box;
  background-color: var(--bg-tertiary);
}
</style>